import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  install: (app, options) => {
    app.component('v-date-picker', VueDatePicker);
  }
};
